import { TextFormView } from '@today/ui-domain'
import { useTextCreate } from '@/hooks/content/useTextCreate'

/** `/content/texts/new` — create a text with its first draft (TO-420 content-admin-ui REQ-003). */
export function TextCreatePage() {
	return <TextFormView {...useTextCreate()} />
}
